import { Spinner } from '@lawpilots/design-system'
import { Box } from '@mui/material'
import { ReactNode } from 'react'

type LoadingPanelProps = {
  /** Defaults to true so the panel drops straight into a Suspense fallback. */
  loading?: boolean
  /** Accessible name announced while the spinner is up; the DS default is English. */
  label?: string
  children?: ReactNode
}

// The same 200px centred well as the app-wide GridProgress, with the DS Spinner in place of
// MUI's CircularProgress. GridProgress backs 26 views, so it keeps its own spinner until a
// ticket can look at all of them.
const WellStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 200,
  width: '100%',
}

export const LoadingPanel = ({ loading = true, label, children = null }: LoadingPanelProps): JSX.Element =>
  loading ? (
    <Box sx={WellStyles}>
      <Spinner size="lg" label={label} />
    </Box>
  ) : (
    <>{children}</>
  )
